<div class="grid gap-4">
  <span class="whitespace-pre-wrap text-xl font-black">{{ title }}</span>
  <p class="whitespace-pre-wrap">{{ question }}</p>
</div>
<div class="mt-8 space-x-4 text-center">
  @if (!justOk) {
    <button
      type="button"
      class="uppercase hover:text-kb-dark-gray m-2 rounded-sm py-2 px-10 focus:ring"
      id="nok"
      (click)="result(false)"
    >
      {{ noBtn || 'NE' }}
    </button>
  }
  <button
    type="button"
    id="ok"
    class="rounded-sm bg-kb px-6 py-3 font-semibold uppercase text-white drop-shadow-sm transition hover:bg-kb-dark m-2 focus:ring"
    (click)="result(true)"
  >
    {{ justOk ? 'OK' : okBtn || 'Ano' }}
  </button>
</div>
